import Pre from './Code.Pre'
import Prism from './Code.Prism'

export default {
  Pre,
  Prism
}
